// application components goes here
import GlobalStyle from "../../../../GlobalStyle";

// styles goes here
import styled from "styled-components";

const Profile = styled.div`
  img {
    border-radius: 100%;
    max-width: 100%;
    width: 90px;
    height: 90px;
    margin: 20px 20px 20px 0;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 75px;
      height: 75px;
      margin: 5px 20px 5px 0;
    }
  }
  .user-title {
    margin: 0;
    font-size: 23px;
    color: #424b50;
    font-family: "Roboto Slab", serif;
    font-weight: 600;
  }
  .user-message {
    font-weight: 600;
    color: #5e7079;
    margin: 0;
    font-family: "robotoregular";
    strong,
    a {
      color: #27ce0a;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
    }
    .span {
      margin: 0 3px;
      color: #27ce0a;
      font-weight: 600;
      cursor: pointer;
    }
  }
`;

const User = (props) => {
  return (
    <>
      <GlobalStyle />
      <Profile>
        <div className="d-flex align-items-center">
          {props.pic ? (
            <div className="flex-shrink-1">
              <img src={props.pic} alt={props.label} />
            </div>
          ) : null}
          <div className="flex-grow-1">
            <p className="user-title">{props.label}</p>
            <p className="user-message">
              Change your email
              <span className="span" onClick={props.onClick}>
                address...
              </span>
            </p>
          </div>
        </div>
      </Profile>
    </>
  );
};

export default User;
